import Charset from '@/api/charset.api.js'

/*eslint-disable */
export const getCharset = ({ commit }, data) => {
  return Charset.getCharset(data)
    .then(response => {
      commit("SET_CHARSETS", response.data)
      return response.data;
    })
}
/*eslint-enable */
